import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, FileText, ChevronDown } from 'lucide-react';
import { useBlueCart } from '../context/BlueCartContext';
import AccountMenu from './auth/AccountMenu';
import logo from "../assets/logo-black.png";

const NAV_LINKS = [
  { label:'Home',               to:'/'       },
  { label:'About',              to:'/about'  },
  { label:'Wholesale',            to:'/catalog'},
];

const TECH_DOC_LINKS = [
  { label:'Warranty',                  to:'/technical/warranty'              },
  { label:'Technical Data Sheet',      to:'/technical/data-sheet'            },
  { label:'Installation Instructions', to:'/technical/installation-instructions' },
];

export default function Navbar({ onDrawerOpen, onCartDrawerOpen }) {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { itemCount } = useBlueCart();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
      <div className="page-container flex items-center justify-between navbar-inner">
        {/* Left */}
        <div className="flex items-center gap-4">
          <img
            src={logo}
            alt="Contractor Rob"
            style={{ display: "block", width: "60px", height: "60px" }}
          />
          <button
            onClick={onDrawerOpen}
            className="icon-btn"
            aria-label="Open menu">
            <Menu size={20} />
          </button>
          <Link to="/" className="flex items-center gap-3 select-none">
            <span
              style={{
                fontFamily: "var(--serif)",
                fontSize: 22,
                color: "var(--ink)",
                letterSpacing: "0.01em",
                lineHeight: 1,
              }}>
              Contractor Rob
            </span>
            <span
              className="hide-sm"
              style={{
                fontFamily: "var(--sans)",
                fontSize: 10,
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "var(--ash)",
                paddingLeft: 12,
                borderLeft: "1px solid var(--rule)",
                marginTop: 2,
              }}>
              Flooring
            </span>
          </Link>
        </div>

        {/* Center nav (desktop) */}
        <ul className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className={`nav-link${location.pathname === link.to ? " active" : ""}`}>
                {link.label}
              </Link>
            </li>
          ))}
          {/* Technical Documents dropdown */}
          <li style={{ position: "relative" }} className="tech-docs-nav">
            <button
              className="nav-link"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "6px 10px",
              }}
              onClick={(e) => {
                const dd = e.currentTarget.nextSibling;
                dd.style.display =
                  dd.style.display === "block" ? "none" : "block";
              }}
              onBlur={(e) => {
                const dd = e.currentTarget.nextSibling;
                setTimeout(() => {
                  if (dd) dd.style.display = "none";
                }, 150);
              }}>
              Technical Documents <ChevronDown size={13} />
            </button>
            <div
              style={{
                display: "none",
                position: "absolute",
                top: "calc(100% + 6px)",
                left: 0,
                minWidth: 220,
                background: "var(--ivory)",
                border: "1px solid var(--rule)",
                borderRadius: "var(--r-md)",
                boxShadow: "0 8px 32px rgba(22,21,18,.12)",
                zIndex: 300,
                overflow: "hidden",
              }}>
              {TECH_DOC_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  style={{
                    display: "block",
                    padding: "11px 16px",
                    fontFamily: "var(--sans)",
                    fontSize: 13,
                    color: "var(--ink)",
                    textDecoration: "none",
                    borderBottom: "1px solid var(--rule)",
                    transition: "background .15s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "var(--ivory-soft)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }>
                  {link.label}
                </Link>
              ))}
            </div>
          </li>
        </ul>

        {/* Right */}
        <div className="flex items-center gap-1">
          <AccountMenu />
          <span
            className="hidden sm:block"
            style={{
              width: 1,
              height: 20,
              background: "var(--rule)",
              margin: "0 4px",
            }}
            aria-hidden="true"
          />
          {/* Blue Cart — opens right drawer */}
          <button
            onClick={onCartDrawerOpen}
            className="icon-btn"
            aria-label={`Quote Cart – ${itemCount} item${itemCount !== 1 ? "s" : ""}`}
            style={{ position: "relative" }}>
            <FileText size={20} />
            {itemCount > 0 && (
              <span className="cart-badge cart-badge-blue">{itemCount}</span>
            )}
          </button>
        </div>
      </div>
    </nav>
  );
}
